import { useRef, useState } from 'react';

import { Check, ContentCopy } from '@mui/icons-material';
import { TableRow, TableCell, Tooltip, styled } from '@mui/material';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

const StyledTableRow = styled(TableRow)`
    & .MuiSvgIcon-root {
        color: ${(props) => props.theme.palette.text.secondary};
        display: flex;

        opacity: 0;
    }

    &:hover {
        cursor: pointer;

        .MuiSvgIcon-root {
            opacity: 1;
        }
    }
`;

export type NetworkingTableRowProps = {
    url: string;
};

export const NetworkingTableRow = (props: NetworkingTableRowProps) => {
    const { url } = props;

    const { t } = useTranslation('common');

    const [hasCopied, setHasCopied] = useState(false);
    const timeoutRef = useRef<number>();

    const tooltipTitle = hasCopied ? t('copied') : t('copy');

    const onCopyURL = () => {
        window.clearTimeout(timeoutRef.current);

        copy(url);

        setHasCopied(true);

        timeoutRef.current = window.setTimeout(() => {
            setHasCopied(false);
        }, 2000);
    };

    return (
        <Tooltip title={tooltipTitle} onClick={onCopyURL} placement="right" arrow>
            <StyledTableRow hover>
                <TableCell>{url}</TableCell>
                <TableCell>{hasCopied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}</TableCell>
            </StyledTableRow>
        </Tooltip>
    );
};
